import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShredder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShredder"><Path d="M2.5 12.5H21.5M4.5 9.5V2.5H19.5V9.5M5.5 15.5V19.5M9.83333 15.5V21.5M14.1667 15.5V19.5M18.5 15.5V21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShredder;
